module.exports = __webpack_public_path__ + "img/gyoza_w_sauce.5e5baf7e.jpg";